"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOperatorIcon = exports.getOperatorTranslationKey = void 0;
var locales_1 = require("../../locales");
exports.getOperatorTranslationKey = function (operator) {
    return locales_1.messages[operator].id;
};
exports.getOperatorIcon = function (operator) {
    var iconNamesDictionary = {
        ALL: "all",
        GREATER_THAN: "greater-than",
        GREATER_THAN_OR_EQUAL_TO: "greater-than-equal-to",
        LESS_THAN: "less-than",
        LESS_THAN_OR_EQUAL_TO: "less-than-equal-to",
        EQUAL_TO: "equal-to",
        NOT_EQUAL_TO: "not-equal-to",
        BETWEEN: "between",
        NOT_BETWEEN: "not-between",
    };
    return iconNamesDictionary[operator];
};
//# sourceMappingURL=measureValueFilterOperator.js.map